import {useEffect} from 'react'
import {Outlet} from 'react-router-dom'
import {BRAND} from '../../brand'

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  return (
    <div
      style={{
        minHeight: '100vh',
        background: BRAND.authGradient,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
      }}
    >
      <Outlet />
    </div>
  )
}

export {AuthLayout}
